module.exports = __webpack_public_path__ + "static/media/GoalSetting.e095908f.png";